<script setup>
import {defineProps, defineEmits, ref, onMounted} from "vue";

const props = defineProps({
  elements: Array,
  parameters: Object,
  coord: Array,
  rowIndex: Number,
  colIndex: Number
})

const emit = defineEmits(['item-dropped', 'drop', 'delete-row', 'delete-col', 'add-col', 'add-row', 'merge-col', 'merge-row', 'split-cell']);

const openPopover = ref(false);
const popoverPosition = ref({left: '0px', top: '0px'});

const fontSizes = [];
for (let i = 4; i <= 72; i++) {
  fontSizes.push(i);
}

onMounted(() => {
  document.addEventListener('keydown', handleKeyDown);
})

function handleKeyDown(e) {
  if (e.key === 'Escape') {
    openPopover.value = false;
  }
}

function showPopover(event) {
  if (!event.target.closest('.popover')) {
    const tdRect = event.currentTarget.getBoundingClientRect();

    const relativeX = event.clientX - tdRect.left;
    const relativeY = event.clientY - tdRect.top;

    popoverPosition.value = {
      left: `${relativeX}px`,
      top: `${relativeY}px`
    };

    openPopover.value = !openPopover.value;
  }
}

function handleDragStart(e, coord) {

  e.dataTransfer.setData('application/json', JSON.stringify({
    sourceCoords: coord,
    sourceParams: props.coord
  }));
  e.currentTarget.style.opacity = '0.4';
}


function handleDragOver(e) {
  e.preventDefault();
  e.currentTarget.classList.add('drag-over');
}

function handleDragLeave(e) {
  e.currentTarget.classList.remove('drag-over');
}

function handleDrop(e) {
  e.preventDefault();
  e.currentTarget.classList.remove('drag-over');
  try {
    const data = JSON.parse(e.dataTransfer.getData('application/json'));

    emit('item-dropped', {
      sourceCoords: data.sourceCoords,
      sourceParams: data.sourceParams,
      targetParams: props.coord,
    });
  } catch (c) {
    emit('drop', {
      position: props.coord
    });
  }
}

function handleDragEnd(e) {
  e.currentTarget.style.opacity = '1';
}


</script>

<template>
  <td
      :colspan="parameters.colspan || 1"
      :rowspan="parameters.rowspan || 1"
      @click="showPopover($event)"

      @dragover="handleDragOver($event)"
      @dragleave="handleDragLeave($event)"
      @drop="handleDrop($event)"
      style="position: relative;"
      :class="{ 'empty-cell': !parameters?.coord }"
  >

    <div v-for="(element, index) in elements" class="cell-content"
         draggable="true"
         @dragstart="handleDragStart($event, parameters.coord[index])"
         @dragend="handleDragEnd($event)"
    >
      <!--      <a v-if="element.link" target="_blank" class="text-primary"-->
      <!--         :href="element.link">{{ element.text }}</a>-->
      <img v-if="element.img" :src="element.img"
           alt="" style="max-width: 150px">
      <span v-else
            :style="{color: parameters.style.color,fontSize: parameters.style.fontSize+3+'pt', fontWeight: parameters.style.bold?700:300}">{{
          element.text.slice(parameters.coord[index][3], parameters.coord[index][4])
        }}</span>
    </div>
    <div class="popover" v-show="openPopover" :style="popoverPosition">
      <div class="line">
        <div class="font-size" v-if="parameters.style.fontSize">
          <select name="" v-model="parameters.style.fontSize" id="" title="Размер шрифта">
            <option v-for="font in fontSizes" :value="font" :key="font">{{ font }}</option>
          </select>
        </div>
        <div class="color" v-if="parameters.style.color">
          <input v-model="parameters.style.color" title="Цвет текста" type="color">
        </div>
        <div class="bold" v-if="parameters.style.bold">
          <button title="Начертание" @click="parameters.style.bold = !parameters.style.bold"
                  :class="`btn btn-sm`+(parameters.style.bold?' btn-outline-dark':'')"><b>B</b></button>
        </div>
      </div>
      <div class="line">
        <button @click="emit('merge-col', {coord: props.coord})" title="Объединить со следующей ячейкой"
                class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-intersect"></i>
        </button>
        <button @click="emit('merge-row', {coord: props.coord})" title="Объединить со следующей строкой"
                class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-intersect"></i>
        </button>
        <button v-if="parameters.colspan-1 || parameters.rowspan-1" @click="openPopover=false; emit('split-cell', {coord: props.coord})" title="Разбить ячейку" class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-exclude"></i>
        </button>

      </div>
      <div class="line">

        <button @click="emit('add-col', {coord: props.coord})" title="Добавить столбец" class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-plus"></i> <i class="bi bi-grip-vertical"></i>
        </button>
        <button @click="emit('delete-col', {coord: props.coord})" title="Удалить столбец" class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-dash"></i><i class="bi bi-grip-vertical"></i>
        </button>
        <button @click="emit('add-row', {coord: props.coord})" title="Добавить строку" class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-plus"></i><i class="bi bi-grip-horizontal"></i>
        </button>
        <button @click="emit('delete-row', {coord: props.coord})" title="Удалить строку" class="btn btn-sm btn-outline-dark text-dark">
          <i class="bi bi-dash"></i><i class="bi bi-grip-horizontal"></i>
        </button>
      </div>
    </div>
  </td>
</template>

<style scoped>
td {
  position: relative;
}

.drag-over {
  background-color: #f0f8ff;
  border: 2px dashed #1e90ff;
}

.empty-cell {
  background-color: #f9f9f9;
}

.cell-content {
  display: inline-block;
  margin-right: 5px;

  span {
    line-break: anywhere;
    line-height: 0.8;
  }
}

.popover {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 3px;
  transform: translateY(10px);

  .line {
    display: flex;
    gap: 10px;

    input {
      height: 20px;
    }

    button {
      height: 20px;
      font-size: 12px;
      line-height: 12px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      font-weight: bolder;
    }
  }


}
</style>